// Global scripts from WP
import Slider from "./modules/components/Slider";
import SubscribeNewsletter from "./modules/components/SubscribeNewsletter";
import Menu from "./modules/Menu";
import SkipLink from "./modules/SkipLink";
import BlogPage from "./pages/BlogPage";
import ServicesPage from "./pages/ServicesPage";
import ServicesSinglePage from "./pages/ServicesSinglePage";
import OrderPage from "./pages/OrderPage";
import CustomerPage from "./pages/CustomerPage";
import CustomersOrdersPage from "./pages/CustomersOrdersPage";
import CustomersOrdersEditPage from "./pages/CustomersOrdersEditPage";
import ExpandableContent from "./modules/components/ExpandableContent";
import Accordion from "./modules/components/Accordion";
import Tooltips from "./modules/components/Tooltips";
import NumberInput from "./modules/components/NumberInput";
import PhoneInput from "./modules/components/PhoneInput";
import CharacterCounter from "./modules/components/CharacterCounter";
import PasswordToggle from "./modules/components/PasswordToggle";
import ShareButton from "./modules/components/ShareButton";
import ServiceDateRequest from "./pages/services/ServiceDateRequest";
import LanguageSwitcher from "./modules/components/LanguageSwitcher";
import LazyLoad from "./modules/LazyLoad";
import PlacesToVisitPage from "./pages/PlacesToVisitPage";
// declare global window localize_script
window.localize_script = localize_script;
// Remove no-js class
document.querySelector('html').classList.remove('no-js');
new LazyLoad();
// Init skip link functionality
new SkipLink();
// Init gsap animations — only load GSAP when the page has animated elements
if (document.querySelector('[data-animation-type]')) {
    import('./modules/Animate').then(({ default: Animate }) => new Animate());
}
// Init slider components.
// Skip sliders that opt out with data-manual-init — those components manage their own Swiper lifecycle.
const sliderComponents = document.querySelectorAll('.slider-default:not([data-manual-init])');
sliderComponents.forEach((component) => {
    new Slider(component);
});
// Init subscribe newsletter components
const subscribeNewsletterComponents = document.querySelectorAll('.subscribe-newsletter');
subscribeNewsletterComponents.forEach((component) => {
    new SubscribeNewsletter(component);
});
// Initialize all number input components
const numberInputWrappers = document.querySelectorAll('.form-field-number');
numberInputWrappers.forEach((wrapper) => {
    new NumberInput(wrapper);
});
// Initialize character counter components
const characterCounterWrappers = document.querySelectorAll('.form-field-with-counter');
characterCounterWrappers.forEach((wrapper) => {
    new CharacterCounter(wrapper);
});
document.querySelectorAll('[data-expandable-section]').forEach((section) => {
    new ExpandableContent(section);
});
document.querySelectorAll('[data-accordion-section]').forEach((section) => {
    new Accordion(section);
});
// Init phone inputs
const phoneInputComponents = document.querySelectorAll('.form-field-tel');
phoneInputComponents.forEach((component) => {
    new PhoneInput(component);
});
// Init password inputs
const passwordInputComponents = document.querySelectorAll('.form-field-password');
passwordInputComponents.forEach((component) => {
    new PasswordToggle(component);
});
// Initialize date request modal
const dateRequestModal = document.querySelector('[data-modal="service-date-request"]');
if (dateRequestModal) {
    new ServiceDateRequest();
}
// Pages
new BlogPage();
new CustomerPage();
new ServicesPage();
new PlacesToVisitPage();
new ServicesSinglePage();
new OrderPage();
new CustomersOrdersPage();
new CustomersOrdersEditPage();
// Menu
new Menu();
new Tooltips();
new ShareButton();
// Initialize language switcher components
const languageSwitcherComponents = document.querySelectorAll('.js-wpml-ls-legacy-dropdown-click');
languageSwitcherComponents.forEach((component) => {
    new LanguageSwitcher(component);
});
